export default __webpack_public_path__ + "static/media/market.2f1784cf.svg";